import React from "react";

class Input extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { props } = this;

        const onInputChange = _.debounce(value => {
            if(props.onSearch) {
                props.onSearch(value);
            }

            props.onUpdateState({options: props.options.filter(item => item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1)})
        }, 300);
        
        const handleChange = e => {
            onInputChange(e.target.value);

            if(e.target.value) {
                props.onUpdateState({inputValue: e.target.value, showSelected: false});
            } else {
                props.onUpdateState({inputValue: e.target.value, showSelected: true});
            }
        }

        return (
            <div class={`searchedInput`}>
                <i class="material-icons">search</i>
                <input 
                    type="text" 
                    class={`${this.props.value !== "" ? "hasInput" : ""} ${props.showSelectedInInput && props.state.selected.value && props.state.showSelected ? "selectedActive" : ""} `}
                    onChange={handleChange} 
                    placeholder={props.placeholder} 
                    value={this.props.value}
                />
            </div>
        )
    }
}

export default Input;